import { useEffect, useState } from "react";

export function useIsMobile(threshold = 500): boolean {
    const [isMobile, setIsMobile] = useState(() => window.innerWidth < threshold);

    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth < threshold);
        };

        handleResize(); // initial check
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, [threshold]);

    return isMobile;
}


export function useIsVerified(): boolean {
    const [isVerified, setIsVerified] = useState(
        () => sessionStorage.getItem('approval_status') === 'true'
    );
    return isVerified

}